/**
 * Development-only logger that is automatically disabled in production builds.
 * This prevents sensitive information from being logged in production while
 * maintaining helpful debugging output during development.
 */

const isDev = import.meta.env.DEV;

export const logger = {
  /**
   * Log general information (only in development)
   */
  info: (...args: any[]) => {
    if (isDev) {
      console.log(...args);
    }
  },

  /**
   * Log warnings (only in development)
   */
  warn: (...args: any[]) => {
    if (isDev) {
      console.warn(...args);
    }
  },

  /**
   * Log errors (only in development)
   */
  error: (...args: any[]) => {
    if (isDev) {
      console.error(...args);
    }
  },

  /**
   * Log debug information with a prefix (only in development)
   */
  debug: (context: string, ...args: any[]) => {
    if (isDev) {
      console.log(`[${context}]`, ...args);
    }
  },

  /**
   * Group related logs together (only in development)
   */
  group: (label: string, fn: () => void) => {
    if (isDev) {
      console.group(label);
      fn();
      console.groupEnd();
    }
  },

  /**
   * Log a table (only in development)
   */
  table: (data: any) => {
    if (isDev) {
      console.table(data);
    }
  },

  /**
   * Time an operation (only in development)
   */
  time: (label: string) => {
    if (isDev) {
      console.time(label);
    }
  },

  /**
   * End timing an operation (only in development)
   */
  timeEnd: (label: string) => {
    if (isDev) {
      console.timeEnd(label);
    }
  },
};
